import { GameTypeName, PremiumGame } from '@loyalty/shared-common/premium-games-api-client';
import { useQuery } from '@tanstack/react-query';
import { useAccounts } from '../../accounts/AccountsContext';
import { useApi } from '../../shared/api-client/ApiClientProvider';

/**
 * Premium games (advanced formats) available to the current account, narrowed down to a single game
 * type. The list is not fetched until a type is selected, because the picker has nothing to show
 * without one. The tenant of the premium games API is the loyalty account.
 */
export function usePremiumGames(gameTypeName?: GameTypeName) {
  const { premiumGamesApi } = useApi();
  const { currentAccount } = useAccounts();
  const tenantId = currentAccount?.id;

  return useQuery({
    queryKey: ['premium-games', tenantId],
    queryFn: () => premiumGamesApi.getGames(tenantId),
    enabled: !!tenantId && !!gameTypeName,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: 'always',
    select: (games: PremiumGame[]) =>
      games
        .filter(game => game.type.name === gameTypeName && game.isCrossTenant === false)
        .sort((a, b) => b.updatedAt.localeCompare(a.updatedAt)),
  });
}
